import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useAutoManagedJoinedInfluencersQuery } from '@anytag/graphql';
import {
  AutoManagedJoinedInfluencersList,
  AutoManagedJoinedInfluencersFilter,
  useAutoManagedJoinedInfluencersFilter
} from '@anytag/shared-organisms';
import { useAutoManagedCampaignDetailsContext } from '../auto-managed-campaign-details-context';

export const AutoManagedJoinedInfluencers = () => {
  const { page, limit, filter } = useAutoManagedJoinedInfluencersFilter();
  const { autoManagedCampaignId } = useAutoManagedCampaignDetailsContext();
  const { data, previousData, loading } = useAutoManagedJoinedInfluencersQuery({
    variables: getValuableVariables({
      limit,
      keyword: filter.keyword,
      id: autoManagedCampaignId,
      offset: getOffset(page, limit)
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.autoManagedJoinedInfluencersCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <AutoManagedJoinedInfluencersFilter totalRecords={totalRecords} autoManagedCampaignId={autoManagedCampaignId} />
      <AutoManagedJoinedInfluencersList
        loading={loading}
        totalRecords={totalRecords}
        data={result?.autoManagedJoinedInfluencers || []}
      />
    </ListWithPagination>
  );
};
